import { useUnit } from 'effector-react'

import { updateAllowedFanNumbersFx } from '@/modules/automations/models/fan-numbering'
import {
  $numberAssignments,
  handleMemberAssign,
  updateNumberAssignment,
} from '@/modules/automations/models/number-assignments'
import { MultiSelect } from '@/modules/shifts/ui/dialogs/multi-select'

interface MemberSelectValueProps {
  number: number
  disabled: boolean
  teamMemberOptions: { label: string; value: string }[]
}

export const MemberSelectValue = ({
  number,
  disabled,
  teamMemberOptions,
}: MemberSelectValueProps) => {
  const numberAssignments = useUnit($numberAssignments)
  const isLoading = useUnit(updateAllowedFanNumbersFx.pending)
  const values = numberAssignments[number] || []

  const handleSelect = (memberIds: string[]) => {
    updateNumberAssignment({ numberIndex: number, memberIds })
    handleMemberAssign({
      numberIndex: String(number),
      memberIds,
    })
  }

  return (
    <div className="w-[300px]">
      <MultiSelect
        className="w-full"
        disabled={disabled || isLoading}
        options={teamMemberOptions}
        disableAllSelect
        value={values}
        onChange={handleSelect}
        entity="Team Members"
        placeholder="Select member"
        searchPlaceholder="Search Team Member"
      />
    </div>
  )
}
